import { endOfMonth, isWeekend, startOfMonth } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { MonthOverview } from '../../types/time-tracking';
import { buildCalendarCells, MonthDayCell } from './month-day-cell';

interface MonthCalendarProps {
  monthAnchor: Date;
  overview: MonthOverview;
  selectedDay: Date | null;
  onSelectDay: (date: Date) => void;
}

export function MonthCalendar({
  monthAnchor,
  overview,
  selectedDay,
  onSelectDay,
}: MonthCalendarProps) {
  const { t } = useTranslation('authenticated.timeTracking');
  const monthStart = startOfMonth(monthAnchor);
  const monthEnd = endOfMonth(monthAnchor);
  const cells = buildCalendarCells(monthStart, monthEnd, overview.days);

  const dowLabels = [
    t('monthView.calendar.dowMon'),
    t('monthView.calendar.dowTue'),
    t('monthView.calendar.dowWed'),
    t('monthView.calendar.dowThu'),
    t('monthView.calendar.dowFri'),
    t('monthView.calendar.dowSat'),
    t('monthView.calendar.dowSun'),
  ];

  return (
    <div className="overflow-hidden rounded-lg border bg-card shadow-sm">
      <div className="grid grid-cols-7 border-b bg-muted/40">
        {dowLabels.map((label, i) => (
          <div
            key={i}
            className="border-l px-2 py-2.5 text-center text-[11px] font-medium uppercase tracking-wide text-muted-foreground first:border-l-0"
          >
            {label}
          </div>
        ))}
      </div>
      <div className="grid auto-rows-[110px] grid-cols-7">
        {cells.map((cell, i) => (
          <MonthDayCell
            key={i}
            day={cell.day}
            date={cell.date}
            isCurrentMonth={cell.isCurrentMonth}
            isWeekend={isWeekend(cell.date)}
            selectedDay={selectedDay}
            onSelect={onSelectDay}
          />
        ))}
      </div>
    </div>
  );
}
